import React from "react";
import AddRemoveCourse from "../AddRemoveCourse/AddRemoveCourse";

export default class PreviewCourse extends React.Component {
  constructor(props) {
    super(props);

    this.onBack = this.onBack.bind(this);
  }

  componentDidMount() {
    var self = this;
    var googleAnalyticsCheckCount = 0;
    function checkIfGoogleAnalyticsLoaded() {
      if (typeof ga != "undefined") {
        var tracker_id = $("#ga_tracker_id").val();

        if (typeof ga != "undefined" && tracker_id) {
          try {
            ga("create", tracker_id, "auto");
            ga(
              "send",
              "event",
              "Course Collection",
              "previewCourse",
              self.props.course_collection.name,
              { nonInteraction: false }
            );
            ga(
              "send",
              "event",
              "Course",
              "previewCourse",
              self.props.course.name,
              { nonInteraction: false }
            );
          } catch (e) {
            //console.log('error with quiz GA', e);
          }
        } else {
          //console.log('ga is undefined')
        }
      } else {
        if (googleAnalyticsCheckCount < 10) {
          googleAnalyticsCheckCount++;
          setTimeout(checkIfGoogleAnalyticsLoaded, 500);
        }
      }
    }
    checkIfGoogleAnalyticsLoaded();
  }

  render() {
    var self = this;

    var articles = this.props.articles.map(function (article) {
      return (
        <li
          key={article.id}
          dangerouslySetInnerHTML={{ __html: article ? article.name : "" }}
        ></li>
      );
    });

    return (
      <div
        className={
          "preview-course " + (this.props.course.number ? "has-number " : " ")
        }
      >
        <h2
          dangerouslySetInnerHTML={{
            __html: this.props.course ? this.props.course.name : "",
          }}
        ></h2>
        <div className="article-content">
          <div className="article-heading">
            <div className="image">
              <img
                src={this.props.image_src}
                alt={"Stock image of " + this.props.name}
              />
              {this.props.course.number ? (
                <span className="number">{this.props.course.number}</span>
              ) : null}
            </div>
            <div className="text">
              <h1
                dangerouslySetInnerHTML={{
                  __html: this.props.article ? this.props.article.name : "",
                }}
              ></h1>
            </div>
          </div>

          <p
            className="abstract"
            dangerouslySetInnerHTML={{
              __html:
                this.props.course && this.props.course.abstract
                  ? this.props.course.abstract
                  : this.props.article.html,
            }}
          ></p>

          <div className="row">
            <div className="col-sm-6">
              <div className="article-intro">
                <h2>What you will learn</h2>
                <ul className="course-article-list">{articles}</ul>
              </div>
            </div>

            {this.props.pre_test_required == "yes" ||
            this.props.post_test_required == "yes" ? null : (
              <div className="col-sm-6">
                <div className="quiz-callout what-do-you-know">
                  <h3>What do you know?</h3>
                  <div className="button-wrapper">
                    <a href={this.props.quiz_path} className="btn">
                      {I18n.t("take_the_quiz")}{" "}
                      <span
                        className="fa fa-pencil-square-o"
                        role="presentation"
                      >
                        &nbsp;
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            )}
          </div>

          <AddRemoveCourse {...this.props} />

          <div className="previous-next-buttons">
            <div className="previous">
              <a
                href="#"
                className="btn go-back"
                tabIndex="0"
                onClick={this.onBack}
              >
                <span className="fa fa-angle-left">&nbsp;</span> Back
              </a>
            </div>
            <div className="next">
              <a href={this.props.path} className="btn next next-article">
                Start now
              </a>
            </div>
          </div>
        </div>

        <span className="fa fa-times" tabIndex="0" onClick={this.onBack}>
          &nbsp;
        </span>
      </div>
    );
  }

  onBack(event) {
    event.preventDefault();
    event.stopPropagation();

    //if (document.referrer) {
    //	window.location.href = document.referrer;
    //} else {
    window.history.back();
    //}
  }
}
